import API from '@api';
import { notifications } from '@utils/notifications';
import {
  clearPaymentReturnPath,
  isTrustedPaymentOrigin,
  savePaymentReturnPath
} from '@utils/paymentReturn';

const SUPPORTED_PAYMENT_IDS = [3, 7, 10, 22];

const pendingPayments = [];
let isMessageListenerAttached = false;

const findPendingIndexBySource = source => {
  if (!source) {
    return -1;
  }
  for (let i = 0; i < pendingPayments.length; i += 1) {
    if (pendingPayments[i].paymentWindow === source) {
      return i;
    }
  }
  return -1;
};

function callbackPaymentEntity(event) {
  if (event.data !== 'paymentProcessEnded') {
    return;
  }
  if (!isTrustedPaymentOrigin(event.origin)) {
    console.log('paymentProcessEnded from untrusted origin', event.origin);
    return;
  }

  let index = findPendingIndexBySource(event.source);

  if (index === -1) {
    index = pendingPayments.length - 1;
  }

  if (index === -1) {
    return;
  }

  const pending = pendingPayments[index];
  pendingPayments.splice(index, 1);

  try {
    if (event.source) {
      event.source.postMessage('paymentProcessAck', '*');
    }
  } catch (error) {
    console.log(error);
  }

  try {
    const windowToClose = event.source || pending.paymentWindow;
    if (windowToClose) {
      windowToClose.close();
    }
  } catch (error) {
    console.log(error);
  }

  if (pending.callback) {
    pending.callback();
  }
}

export default {
  execute: (order, callback = () => {}, returnPath) => {
    let payment = false;

    if (typeof order.payment_id !== 'undefined') {
      payment = order.payment_id;
    }

    if (
      typeof order.payment !== 'undefined' &&
      typeof order.payment.id !== 'undefined'
    ) {
      payment = order.payment.id;
    }

    if (!payment) {
      console.log('Payment not valid');
      return;
    }

    if (SUPPORTED_PAYMENT_IDS.indexOf(Number(payment)) === -1) {
      console.log(`Payment not support: ${payment}`);
      return;
    }

    savePaymentReturnPath(returnPath);

    const paymentWindow = window.open();

    API.createPayLink({
      id: parseInt(order.id, 10)
    })
      .then(data => {
        if (data === null) {
          return Promise.reject();
        }

        const hash = data.createPayLink;

        // paymentWindow.location = 'https://www.delikateska.ru/pay-link/' + hash;
        paymentWindow.location = `https://cart.delikateska.ru/pay-link/${hash}`;

        pendingPayments.push({
          orderId: order.id,
          paymentWindow,
          callback
        });

        if (!isMessageListenerAttached) {
          window.addEventListener('message', callbackPaymentEntity);
          isMessageListenerAttached = true;
        }
      })
      .catch(e => {
        console.log(e);
        if (!pendingPayments.length) {
          clearPaymentReturnPath();
        }
        notifications(
          'Мы не смогли сгенерировать ссылку на оплату, попробуйте снова',
          'Ошибка'
        );
      });
  }
};
